import { PurchaseOrderType } from 'api'
import { PurchaseOrderSubLineAccessor } from 'types'

import { redeliveryEditModeColumns } from 'modules/purchaseOrders/constants/redeliveryColumns'
import { vendorReleaseEditModeColumns } from 'modules/purchaseOrders/constants/vendorReleaseColumns'

export const getSubLineValue = (poType: PurchaseOrderType, visibleSubColumns: string[]) => {
  switch (poType) {
    case PurchaseOrderType.VendorRelease:
      return visibleSubColumns.filter((option) =>
        vendorReleaseEditModeColumns.includes(option as PurchaseOrderSubLineAccessor),
      )

    case PurchaseOrderType.Redelivery:
      return visibleSubColumns.filter((option) =>
        redeliveryEditModeColumns.includes(option as PurchaseOrderSubLineAccessor),
      )

    default:
      return undefined
  }
}
